/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Lastchange1Inputs */

const en__field_lastchange1 = /** @type {(inputs: _Field_Lastchange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`last change`)
};

const de__field_lastchange1 = /** @type {(inputs: _Field_Lastchange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`letzte Änderung`)
};

/**
* | output |
* | --- |
* | "last change" |
*
* @param {_Field_Lastchange1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_lastchange1 = /** @type {((inputs?: _Field_Lastchange1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Lastchange1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_lastchange1(inputs)
	return de__field_lastchange1(inputs)
});
export { _field_lastchange1 as "_field_lastChange" }